import React from "react";
import PickMeals from "../Assets/pick-meals-image.png";
import ChooseMeals from "../Assets/choose-image.png";
import DeliveryMeals from "../Assets/delivery-image.png";
import { Fa0, Fa1 } from "react-icons/fa6";
import { AiFillLock } from "react-icons/ai";
import { IoKeyOutline } from "react-icons/io5";

const Work = () => {
	const workInfoData = [
		{
			image: IoKeyOutline,
			title: "Encryption",
			text: "Data is Encrypted in transit.",
		},
		{
			image: ()=>{
				const size = 35
				return (
					<div style={{marginBottom: 60}}>
						<Fa1 size={size} />
						<Fa0 size={size} />
						<Fa1 size={size} />
						<Fa0 size={size} />
						<Fa0 size={size} />
						<Fa1 size={size} />
					</div>
				)
			},
			title: "Hashing",
			text: "Anonymous entries are one-way hashed. Even if we were hacked, anonymous entries still won't be identified to a specific user",
		},
		{
			image: AiFillLock,
			title: "Private Entries",
			text: "Private Entries are never shared publicly. Only you can view them",
		},
	];
	return (
		<div className="work-section-wrapper">
			<div className="work-section-top">
				{/* <p className="primary-subheading">Work</p> */}
				<h1 className="primary-heading">How we Protect Data</h1>
				<p className="primary-text">
					We are committed to protecting yout identity and information.
				</p>
			</div>
			<div className="work-section-bottom">
				{workInfoData.map((data) => (
					<div className="work-section-info" key={data.title}>
						<div className="info-boxes-img-container">
							{/* <img src={data.image} alt="" /> */}
							{
								<data.image size={100} color="black" />
							}
						</div>
						<h2>{data.title}</h2>
						<p>{data.text}</p>
					</div>
				))}
			</div>
		</div>
	);
};

export default Work;
